module.exports = __webpack_public_path__ + "theme-good.f0de703f891f4d4ff8cdcd6eea196c21.hashedasset.png";